import React from "react";
import { RenderSecure } from "../../../util/script/RenderSecure";

const MMTransactionsSearchForm = ({
  searchTerm,
  type,
  setSearchTerm,
  setType,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  searchTransactions,
  resetSearch,
  setPage
}) => {
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    searchTransactions(e);
  };

  const handleReset = (e) => {
    e.preventDefault();
    resetSearch(e);
  };

  const handleSearchTermChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setPage(1);
    if (value === '') {
      resetSearch(e);
    }
};

  return (
    <form className="mg-t-20" onSubmit={handleSearchSubmit}>
      <div className="row gutters-5">
        <div className="col-9-xxxl col-lg-9 col-12 form-group">
          <div className="row">
            <div className="col-lg-4">
              <input
                type="text"
                placeholder="Enter name or number..."
                style={{ border: "1px solid grey" }}
                value={searchTerm}
                onChange={handleSearchTermChange}
                className="form-control"
              />
            </div>
            <RenderSecure code="ADMIN-VIEW"><div className="col-lg-3">
            <select
                    style={{border: "1px solid grey"}}
                    className="col-12 form-control"
                    value={type}
                    onChange={(e) => setType(e.target.value)}>
                    <option value="" selected disabled>Select transaction type..</option>
                    <option value="1">Buzztime Load</option>
                    <option value="9">Pocket Money Deposits</option>
                    <option value="10">Vendor Disbursements</option>
                    <option value="4">Card Activations</option>
                    <option value="12">Wristband Activations</option>
                    <option value="11">Card Replacements</option>
                    <option value="13">Wristband Replacements</option>

                </select>
            </div></RenderSecure>
            <div className="col-lg-5">
              <div className="flex-fill position-relative">
                <div className="input-group input-daterange" id="datepicker">
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="start date"
                  />
                  <span
                    className="input-group-text"
                    style={{
                      marginLeft: "-1px",
                      borderTopLeftRadius: "0",
                      borderTopRightRadius: "0",
                      borderBottomLeftRadius: "0",
                      borderBottomRightRadius: "0",
                    }}
                  >
                    to
                  </span>
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="form-control"
                    placeholder="end date"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-3-xxxl col-lg-3 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue"
          >
            SEARCH
          </button>
          <button
            type="button"
            onClick={handleReset}
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-martini ml-2"
          >
            RESET
          </button>
        </div>
      </div>
    </form>
  );
};

export default MMTransactionsSearchForm;